import gql from "graphql-tag";

export default gql`
  query UserAccounts($filter: UserAccountFilter!, $sorting: Sorting) {
    userAccounts(filter: $filter, sorting: $sorting) {
      results {
        id
        createdAt
        emailAddress
        firstName
        lastName
        role
        deactivated
        confirmed
        personalNote
        phoneNumber
        userStatus
        scuContent {
          scuTrainer
        }
      }
      total
    }
  }
`;
